import { getUserId } from '$lib/global/storage';
import { getBlockImportPromises } from '$lib/helper';
import { appendDomainQueryParam } from '$lib/utils/appendDomainQueryParam';
import { getDataBaseUrl } from '$lib/utils/getDataBaseUrl';
import { initSessionId } from '$lib/utils/initSessionId';

import debug from 'debug';

import type { PageLoad } from './$types';

const debugLog = debug('routes:+page.js');

export const load: PageLoad = async ({ fetch }) => {
    initSessionId();

    const userId = getUserId() || 'error';
    const sessionId = window.sessionId || 'error';
    const dataBasePath = getDataBaseUrl();
    const res = await fetch(
        `${dataBasePath}/indexPage.json?v=${
            window.campaignVersionId
        }&uid=${userId}&sid=${sessionId}${appendDomainQueryParam()}`,
    );
    const pageData = await res.json();

    debugLog(pageData);

    // Preload all page blocks (triggered by NextPageNavigator.preload)
    const blockImportPromises = getBlockImportPromises(pageData?.components);
    await Promise.all(blockImportPromises);

    return pageData;
};
